import React from 'react';
import { Box, Modal, Grid, Select, Stack, MenuItem } from '@mui/material';
import { AppButton } from '../../../../resources/styling';
import { colors } from '../../../../resources/theme/colors';
import { TextField } from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { tagService } from '../../../../services/api/insights/tagService';
import { OutlineButton } from '../../../../resources/styling/appStyle';

const { mandy, pictonBlue } = colors;

export function MergeTag({ tags, closeModal, updateAfterMerge }) {
  const [selectedTag1, setSelectedTag1] = React.useState(null);
  const [selectedTag2, setSelectedTag2] = React.useState(null);
  const [tag3, setTag3] = React.useState(null);
  const [showOutput, setShowOutput] = React.useState({
    open: false,
    message: '',
    type: 'success',
  });

  return (
    <Modal open={true} center styles={{ modal: { width: '50%' } }}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',          
          bgcolor: 'background.paper',          
          p: 3,
        }}
      >
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          open={showOutput.open}
          autoHideDuration={6000}
          onClose={() => setShowOutput({ ...showOutput, open: false })}
        >
          <Alert
            variant='filled'
            onClose={() => setShowOutput({ ...showOutput, open: false })}
            severity={showOutput.type}
            sx={{ width: '100%' }}
          >
            {showOutput.message}
          </Alert>
        </Snackbar>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Stack direction='row' alignItems='center'>
              <h2>Merge Tags</h2>
            </Stack>
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <div className='form-label'>Tag One</div>
            <Select
              fullWidth
              value={selectedTag1}
              onChange={(e) => setSelectedTag1(e.target.value)}
            >
              {tags.map((tag) => (
                <MenuItem key={tag.id} value={tag}>
                  {tag.name}
                </MenuItem>
              ))}
            </Select>
          </Grid>
          
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <div className='form-label'>Tag Two</div>
            <Select
              fullWidth
              value={selectedTag2}
              onChange={(e) => setSelectedTag2(e.target.value)}
            >
              {tags.map((tag) => (
                <MenuItem key={tag.id} value={tag}>
                  {tag.name}
                </MenuItem>
              ))}
            </Select>
          </Grid>          
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <div className='form-label'>Merge Tag</div>
            <TextField
              placeholder='Tag Name'
              fullWidth
              value={tag3}
              onChange={(e) => setTag3(e.target.value)}
            />
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Stack direction="row" gap={1} justifyContent="flex-end">
              <OutlineButton                
                onClick={() => {
                  closeModal(true);
                }}                
              >
                Cancel
              </OutlineButton>
              <AppButton
                color={mandy}
                onClick={() => {
                  if (selectedTag1 === null || selectedTag2 === null) {
                    setShowOutput({
                      open: true,
                      message: 'Please select two tags to merge',
                      type: 'error',
                    });
                    return;
                  }
                  if (selectedTag1?.id === selectedTag2?.id) {
                    setShowOutput({
                      open: true,
                      message: 'Tags cannot be the same',
                      type: 'error',
                    });
                    return;
                  }
                  if (tag3 === null || tag3 === '') {
                    setShowOutput({
                      open: true,
                      message: 'Please enter a name for the merged tag',
                      type: 'error',
                    });
                    return;
                  }
                  tagService
                    .mergeTag({ tag1: selectedTag1, tag2: selectedTag2, tag3: tag3 })
                    .then((res) => {
                      setShowOutput({
                        open: true,
                        message: 'Tags merged successfully',
                        type: 'success',
                      });
                      updateAfterMerge(selectedTag1, selectedTag2, res);
                      setSelectedTag1(null);
                      setSelectedTag2(null);
                      setTag3(null);
                      closeModal();
                    })
                    .catch((err) => {
                      setShowOutput({
                        open: true,
                        message: 'Error merging tags',
                        type: 'error',
                      });
                    });
                }}
              >
                Merge
              </AppButton>
            </Stack>
          </Grid>
         
        </Grid>
        
      </Box>
    </Modal>
  );
}
